export default __webpack_public_path__ + "static/media/product-10 (2).ea36110b.jpg";